import { Button, ButtonProps, styled } from "@mui/material";
import { Iconify } from "..";

const RootStyle = styled(Button)(({ theme }) => ({
  padding: theme.spacing(0.5, 1),
  fontSize: "0.75rem",
  color: "inherit",
  backgroundColor: theme.palette.grey[300],
  "&:hover": {
    backgroundColor: theme.palette.grey[300],
  },
}));

interface AddressButtonProps extends ButtonProps {
  address: string;
  target: "_blank";
}

export const AddressButton = ({ address, ...props }: AddressButtonProps) => {
  return (
    <RootStyle endIcon={<Iconify icon="majesticons:open-line" />} {...props}>
      {`0x${address ? address.slice(2, 6) + "..." + address.slice(-4) : ""}`}
    </RootStyle>
  );
};
